import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { baseUrl, modal_excel_icon, sorticon } from '../../../api/baseUrl';
import Header from '../../../common/header/header';
import Nav from '../nav';
import Paginate from 'react-paginate';
import LoadingImage from '../../../assets/media/loader.gif';
import { Pagination, rem } from '@mantine/core';
import { formatMoney } from '../../../GlobalFunctions';
import { DatePickerInput } from '@mantine/dates';
import { IconCalendar, IconChevronDown } from '@tabler/icons-react';
import { MultiSelect } from '@mantine/core';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const Coal = () => {
  const [coal, setCoal] = useState([]);
  const [filter, setFilter] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [cookies] = useCookies();
  const [brandValue, setBrandValue] = useState([]);
  const [dateValue, setDateValue] = useState();
  const [nameValue, setNameValue] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const currentPosts = filteredData;
  const [url, setUrl] = useState(
    `${baseUrl}/coal?page=${currentPage}&postsperpage=${postsPerPage}`
  );
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending',
  });

  const calendaricon = (
    <IconCalendar style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );
  const icon = (
    <IconChevronDown style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
  );

  // useEffect(() => {
  //   let result = coal;
  //   if (coal.length && brandValue.length) {
  //     setUrl(url + 'name=' + brandValue.toString());
  //     result = handleFilterBrand(result);
  //   }
  //   if (coal.length && dateValue !== undefined) {
  //   }
  // }, [nameValue]);

  useEffect(() => {
    fetchRecords(url);
  }, [url]);

  const fetchRecords = (url) => {
    fetch(url, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${cookies?.accessToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCoal(data.data);
        setFilteredData(data.data);
        setCount(data.count);
        setFilter(data.filter);
        setIsLoading(true);
      });
  };
  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });

    setFilteredData(sortedData);
  };

  // const handleFilterBrand = (data) => {
  //   var brandValueLowerCase = brandValue.map((item) => item.toLowerCase());
  //   if (brandValue.length) {
  //     var brand_filter = data.filter((item) =>
  //       brandValueLowerCase.includes(item.name.toLowerCase())
  //     );
  //   }
  //   return brand_filter;
  // };

  const paginate = (page) => {
    setCurrentPage(page);
    setUrl(`${baseUrl}/coal?page=${page}&postsperpage=${postsPerPage}`);
  };

  function removeParam(key, sourceURL) {
    var rtn = sourceURL.split('?')[0],
      param,
      params_arr = [],
      queryString =
        sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
    if (queryString !== '') {
      params_arr = queryString.split('&');
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split('=')[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length) rtn = rtn + '?' + params_arr.join('&');
    }
    return rtn;
  }

  const handleDateValue = (value) => {
    let url2 = url;
    url2 = removeParam("date", url2);
    if (value !== undefined && value[0] !== null && value[1] !== null) {
      const sd_time = new Date(value[0]).getTime() / 1000;
      const ed_time = new Date(value[1]).getTime() / 1000;
  
      if (value.length) {
        setCurrentPage(1);
        url2 = url2.replace(`page=${currentPage}`, `page=1`);
        url2 += `&date=${[sd_time, ed_time].toString()}`;
      }
      setDateValue(value);
      console.log("Current Page (Date Filter): 1");
    }
    setUrl(url2);
  };

  const handleBrandValue = (value) => {
    if (value !== undefined && value !== null) {
      let url2 = url;
      url2 = removeParam('name', url2);
      if (value.length) {
        url2 += `&name=${value.toString()}`;
        setCurrentPage(1);
      }
      setBrandValue(value);
      setUrl(url2);
    }
  };

  const handlePostsPerPage = (e) => {
    setCurrentPage(1);
    var url2 = url.replace(
      `postsperpage=` + postsPerPage,
      `postsperpage=` + e.target.value
    );
    setUrl(url2);
    setPostsPerPage(e.target.value);
  };

  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  today = dd + '-' + mm + '-' + yyyy;

  return (
    <>
      <Header />
      <div className="analyst cement-main-sec steel-main-section">
        <div className="row omcboxed" style={styles.navWidth}>
          <Nav nopadding={true} />
        </div>
        {isLoading ? (
          <div className="datatable-container container container_box cement-date-row steel-main-sec">
            <div className="excel-btn">
              <div className="row-maintine">
                <div className="select_drop">
                  <select
                    className="selectpicker"
                    value={postsPerPage}
                    onChange={handlePostsPerPage}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <span style={styles.excel}>
                <ReactHTMLTableToExcel
                  className="download-table-xls-button"
                  table="table"
                  filename={'Steel_' + today}
                  sheet="Steel"
                  buttonText={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: modal_excel_icon,
                      }}
                    />
                  }
                />{' '}
              </span>
            </div>
            <div className="ask-table-format">
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th onClick={() => handleSort('date')}>
                    <div className="cement-steel-tbl">
                      Date
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>

                  <th onClick={() => handleSort('name')}>
                    <div className="cement-steel-tbl">
                      Brand
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>
                  <th onClick={() => handleSort('unit')}>
                    <div className="cement-steel-tbl justify-center">
                      Unit
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>

                  <th onClick={() => handleSort('price')}>
                    <div className="cement-steel-tbl justify-align">
                      Price
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>
                </tr>
                <tr className="second-table-row">
                  <th className="date-sizing steel-data-row">
                    <div>
                      {/* <h1>Form</h1> */}
                      <DatePickerInput
                        icon={<IconCalendar size="1.1rem" stroke={1.5} />}
                        clearable
                        // leftSection={calendaricon}
                        maxDate={new Date()}
                        type="range"
                        valueFormat="DD MMM, YYYY"
                        // dropdownType="modal"
                        placeholder="Select Date Range"
                        // value={dateValue}
                        onChange={handleDateValue}
                        mx="auto"
                      />
                    </div>
                  </th>

                  <th className="date-sizing">
                    <MultiSelect
                      data={filter.brand}
                      value={brandValue}
                      onChange={handleBrandValue}
                      rightSection={icon}
                      placeholder="Select Brand"
                      searchable
                    />
                  </th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length ? (
                  filteredData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.date}</td>
                      <td>{item.name}</td>
                      <td className="center-align">{item.unit}</td>
                      <td className="right-align">{formatMoney(item.price)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="dropdown-pagination">
                <Pagination
                  total={Math.ceil(count / postsPerPage)}
                  value={currentPage}
                  onChange={paginate}
                  mt="sm"
                  size="xs"
                />
                </div>
                </div>
          </div>
        ) : (
          <div
            style={{ width: '100%', height: '100%', color: '#426fd7' }}
            className="main-loader d-flex flex-column justify-content-center align-items-center"
          >
            <img
              src={LoadingImage}
              style={{ height: '500px' }}
              alt="Loading..."
            />
          </div>
        )}
      </div>
    </>
  );
};

const styles = {
  navWidth: {
    width: '100%',
    fontSize: '14px',
    margin: 'auto',
    marginBottom: '10px',
    justifyContent: 'space-between',
  },
};

export default Coal;
